import React from 'react'
import './Todolist.css'

const Todolist = (props) => {
  return (
    <>
    <div className='list-delete'>
      <li className='list-item'>
        {props.item}
        <span className='icons'>
        <i className="fa-solid fa-trash-can" onClick={(e)=>{
            props.deleteItem(props.index);
        }}></i>
        </span>
      </li>
      </div>
    </>
  )
}

export default Todolist
